// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1asjB","signatureBlock":"Footer_signatureBlock__2ZuBq","signature":"Footer_signature__jjvSW"};